export const ALERT_ACTION_TYPES = {

	SHOW_ALERT: 'SHOW_ALERT',
	HIDE_ALERT: 'HIDE_ALERT',
	
}